import { alpha } from "@mui/material/styles"
import { dsColorNew } from "@palette"


// Notices (react-toastify) in the corporate look: white card, a colour strip by type, the icon in a tinted
// square and a thin timer. Only the look changes: messages, position and timing stay as each screen sets them.
const tone = (accent, tint, iconColor) => ({
	'--toast-accent': accent,
	'& .Toastify__toast-icon': { backgroundColor: tint, '& svg': { fill: iconColor } },
})

export const toastGlobalStyles = {
	'.Toastify__toast': {
		'--toast-accent': dsColorNew.appBlue,
		position: 'relative',
		overflow: 'hidden',
		minHeight: 56,
		padding: '12px 14px 12px 18px',
		borderRadius: '12px',
		border: `1px solid ${dsColorNew.grayBorder}`,
		backgroundColor: dsColorNew.white,
		color: dsColorNew.textDark,
		boxShadow: `0 12px 32px ${alpha(dsColorNew.navy, 0.14)}`,
		fontFamily: 'Roboto, sans-serif',
		'&::before': { content: '""', position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, backgroundColor: 'var(--toast-accent)' },
	},
	'.Toastify__toast-body': { padding: 0, alignItems: 'flex-start', fontSize: 14, fontWeight: 500, lineHeight: 1.45, color: dsColorNew.textTitle },
	'.Toastify__toast-icon': {
		width: 30, height: 30, flexShrink: 0, marginInlineEnd: '12px', borderRadius: '8px',
		display: 'flex', alignItems: 'center', justifyContent: 'center',
		'& svg': { width: 16, height: 16 },
	},
	'.Toastify__toast-body > div:last-of-type': { alignSelf: 'center' },
	'.Toastify__close-button': { color: dsColorNew.textSubtle, opacity: 1, alignSelf: 'flex-start', '&:hover': { color: dsColorNew.textMuted } },
	'.Toastify__progress-bar': { height: 2, left: 4, opacity: 1, background: 'var(--toast-accent)' },
	'.Toastify__progress-bar--bg': { display: 'none' },
	'.Toastify__toast--success': tone(dsColorNew.successBar, dsColorNew.successBg, dsColorNew.successText),
	'.Toastify__toast--error': tone(dsColorNew.dangerRed, dsColorNew.dangerBg, dsColorNew.dangerRed),
	'.Toastify__toast--warning': tone(dsColorNew.warningBar, dsColorNew.noteAmberBg, dsColorNew.noteAmber),
	'.Toastify__toast--info': tone(dsColorNew.appBlue, dsColorNew.noteInfoBg, dsColorNew.noteInfo),
	'.Toastify__toast--default': tone(dsColorNew.appBlue, dsColorNew.noteInfoBg, dsColorNew.noteInfo),
	// confirmations draw their own icon and buttons (AppConfirmToast); the strip follows what they confirm
	'.Toastify__toast.app-toast-danger': { '--toast-accent': dsColorNew.dangerRed },
	'.Toastify__toast.app-toast-warning': { '--toast-accent': dsColorNew.warningBar },
}
